import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { FolderPersonObject } from '@libs/types/src/services/object-type/folder/folder-person.object';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { FolderPersonsStore } from '../folder-persons.store';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { AppFormGroup } from '../../../../../utils/form.utils';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { DateInputComponent } from '../../../../kit/input/date-input/date-input.component';
import { TextAreaInputComponent } from '../../../../kit/input/text-area-input/text-area-input.component';
import { SaveButtonComponent } from '../../../../kit/button/save-button.component';
import { CancelButtonComponent } from '../../../../kit/button/cancel-button.component';

/**
 * Odebrání osoby ze složky - pobyt se uzavře zadaným datem a zůstane v historii pobytů.
 * Data dialogu: { folderPerson: FolderPersonObject }
 */
@Component({
    selector: 'app-folder-person-remove-dialog',
    templateUrl: 'folder-person-remove-dialog.component.html',
    providers: [FolderPersonsStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DateInputComponent,
        TextAreaInputComponent,
        SaveButtonComponent,
        CancelButtonComponent,
    ],
})
export class FolderPersonRemoveDialogComponent extends BaseDialogComponent {

    public readonly store = inject(FolderPersonsStore);

    protected readonly prefix = 'folder.persons.';

    protected readonly folderPerson: FolderPersonObject = this.dialogConfig.data?.folderPerson;

    protected form = new AppFormGroup({
        dateTo: fb.control<Date | null>(new Date(), Validators.required),
        note: fb.control<string | null>(null),
    });

    public override async save(_event?: Event): Promise<void> {
        if (this.form.isInvalid()) return;

        await this.store.api.removeFolderPerson({
            id: this.folderPerson.id,
            dateTo: this.form.value.dateTo!.toISOString(),
            note: this.form.value.note || null,
        });

        contentGlobalSuccess.next(`${this.prefix}messages.removed`);
        this.dialogRef.close(true);
    }

}
